const object = [
  {
    "web-scraper-order": "1666025941-936",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🚰 Potable Water",
    "objects-href": "https://emojipedia.org/potable-water/",
    emoji: "🚰",
    emojiName: "🚰 Potable Water",
    description:
      "A symbol for potable (drinkable) water, usually shown with a faucet filling a drinking glass. Commonly used for various content concerning water, drinking, thirst, and dripping.",
  },
  {
    "web-scraper-order": "1666025944-939",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🪪 Identification Card",
    "objects-href": "https://emojipedia.org/identification-card/",
    emoji: "🪪",
    emojiName: "🪪 Identification Card",
    description:
      "An identification card with a portrait and words. May be used to remind people to bring or show an id. May also be used in the context of a fake id.",
  },
  {
    "web-scraper-order": "1666025947-941",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🪧 Placard",
    "objects-href": "https://emojipedia.org/placard/",
    emoji: "🪧",
    emojiName: "🪧 Placard",
    description:
      "A sign on a post, commonly used to promote ideas, causes, or make announcements. Often used used in the context of politics to represent a lawn sign or a poster brought to a protest. Also seen in commercial advertising.",
  },
  {
    "web-scraper-order": "1666025949-942",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🗿 Moai",
    "objects-href": "https://emojipedia.org/moai/",
    emoji: "🗿",
    emojiName: "🗿 Moai",
    description:
      "A moai, one of the famed, giant stone statues of human figures on Easter Island. Depicted as a gray stone carving of a stylized human head with a prominent brow and nose, most often facing left.",
  },
  {
    "web-scraper-order": "1666025955-945",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "⚱️ Funeral Urn",
    "objects-href": "https://emojipedia.org/funeral-urn/",
    emoji: "⚱️",
    emojiName: "⚱️ Funeral Urn",
    description:
      "An urn, as used to hold the cremated ashes of the dead. Appearance varies, but generally depicted as a covered, bronze container with a rounded body and tapered foot.",
  },
  {
    "web-scraper-order": "1666025959-948",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🪦 Headstone",
    "objects-href": "https://emojipedia.org/headstone/",
    emoji: "🪦",
    emojiName: "🪦 Headstone",
    description:
      "A headstone or tombstone, used to mark graves. Appearance varies from platform to platform, with different shapes and inscriptions.",
  },
  {
    "web-scraper-order": "1666025961-950",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "⚰️ Coffin",
    "objects-href": "https://emojipedia.org/coffin/",
    emoji: "⚰️",
    emojiName: "⚰️ Coffin",
    description:
      "A traditional coffin, as used to bury the dead. Depicted at various angles as a closed, six-sided, wooden coffin, tapered at the head and foot with golden handles.",
  },
  {
    "web-scraper-order": "1666025964-953",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🚬 Cigarette",
    "objects-href": "https://emojipedia.org/cigarette/",
    emoji: "🚬",
    emojiName: "🚬 Cigarette",
    description:
      "A lit, filtered cigarette, shown burning at different directions. Commonly used to represent various forms of smoking (e.g., tobacco, marijuana, vaping) as well as metaphorical senses of smoking.",
  },
  {
    "web-scraper-order": "1666025966-955",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🛒 Shopping Cart",
    "objects-href": "https://emojipedia.org/shopping-cart/",
    emoji: "🛒",
    emojiName: "🛒 Shopping Cart",
    description:
      "Shopping Cart was approved as part of Unicode 9.0 in 2016 under the name “Shopping Trolley” and added to Emoji 3.0 in 2016.",
  },
  {
    "web-scraper-order": "1666025969-958",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🧯 Fire Extinguisher",
    "objects-href": "https://emojipedia.org/fire-extinguisher/",
    emoji: "🧯",
    emojiName: "🧯 Fire Extinguisher",
    description:
      "A fire extinguisher, as used to put out small fires. Depicted as a red tank with a black hose and pressure gauge. Most platforms include an image of a flame on a white label.",
  },
  {
    "web-scraper-order": "1666025971-961",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🧽 Sponge",
    "objects-href": "https://emojipedia.org/sponge/",
    emoji: "🧽",
    emojiName: "🧽 Sponge",
    description:
      "A peanut-shaped sponge, as used for cleaning or bathing. Generally depicted in yellow and at different angles across platforms. Commonly used for various content concerning bathing, washing, and cleaning.",
  },
  {
    "web-scraper-order": "1666025974-963",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🪥 Toothbrush",
    "objects-href": "https://emojipedia.org/toothbrush/",
    emoji: "🪥",
    emojiName: "🪥 Toothbrush",
    description: "A brightly colored plastic toothbrush with white bristles.",
  },
  {
    "web-scraper-order": "1666025976-966",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🧼 Soap",
    "objects-href": "https://emojipedia.org/soap/",
    emoji: "🧼",
    emojiName: "🧼 Soap",
    description:
      "A bar of soap, as used in the shower, bath or for hand washing. Generally shown with lathered bubbles. Depicted in various colors, often pink, and at different angles.",
  },
  {
    "web-scraper-order": "1666025978-968",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🪣 Bucket",
    "objects-href": "https://emojipedia.org/bucket/",
    emoji: "🪣",
    emojiName: "🪣 Bucket",
    description:
      "A blue or green bucket or pail. Used to talk about real or metaphorical buckets.",
  },
  {
    "web-scraper-order": "1666025981-970",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🧻 Roll of Paper",
    "objects-href": "https://emojipedia.org/roll-of-paper/",
    emoji: "🧻",
    emojiName: "🧻 Roll of Paper",
    description:
      "A roll of paper, as toilet paper (toilet tissue). May also be a roll of kitchen/paper towels. Depicted at various angles, with a sheet unfurling.",
  },
  {
    "web-scraper-order": "1666025983-973",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🧺 Basket",
    "objects-href": "https://emojipedia.org/basket/",
    emoji: "🧺",
    emojiName: "🧺 Basket",
    description:
      "A basket, as used for storing or carrying such things as food or clothes. Appearance widely varies across platforms but generally depicted as woven from wicker with one or more handles. Commonly used to represent doing laundry or having a picnic.",
  },
  {
    "web-scraper-order": "1666025985-975",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🧹 Broom",
    "objects-href": "https://emojipedia.org/broom/",
    emoji: "🧹",
    emojiName: "🧹 Broom",
    description:
      "A traditional broom, as used for sweeping—or ridden by a witch. Shown at a 45° angle, with a wooden handle and yellow bristles at the lower left.",
  },
  {
    "web-scraper-order": "1666025988-979",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🧷 Safety Pin",
    "objects-href": "https://emojipedia.org/safety-pin/",
    emoji: "🧷",
    emojiName: "🧷 Safety Pin",
    description:
      "A silver safety pin or clip, as used to fasten fabric. Generally shown clasped at a 45° angle, with its spring at the lower left.",
  },
  {
    "web-scraper-order": "1666025991-981",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🧴 Lotion Bottle",
    "objects-href": "https://emojipedia.org/lotion-bottle/",
    emoji: "🧴",
    emojiName: "🧴 Lotion Bottle",
    description:
      "A bottle of lotion for the skin, such as moisturizer or sunscreen (sunblock). May be used for other hygienic liquids, including shampoo and body wash, as well as beauty products.",
  },
  {
    "web-scraper-order": "1666025993-984",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🪒 Razor",
    "objects-href": "https://emojipedia.org/razor/",
    emoji: "🪒",
    emojiName: "🪒 Razor",
    description: "A safety razor, depicted in various colors across platforms.",
  },
  {
    "web-scraper-order": "1666025996-986",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🪤 Mouse Trap",
    "objects-href": "https://emojipedia.org/mouse-trap/",
    emoji: "🪤",
    emojiName: "🪤 Mouse Trap",
    description:
      "A trap used to catch a mouse, rat, or other unwanted rodent. Metaphorically used in emoji form to suggest any kind of trap or entrapment.",
  },
  {
    "web-scraper-order": "1666025998-989",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🛁 Bathtub",
    "objects-href": "https://emojipedia.org/bathtub/",
    emoji: "🛁",
    emojiName: "🛁 Bathtub",
    description:
      "A white bathtub with a silver shower head. Often depicted as a cast-iron tub with claw-foot legs. Commonly used for various content concerning bathing, washing, cleaning, and bathrooms more generally.",
  },
  {
    "web-scraper-order": "1666026001-991",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🚿 Shower",
    "objects-href": "https://emojipedia.org/shower/",
    emoji: "🚿",
    emojiName: "🚿 Shower",
    description:
      "A silver shower head, streaming water to the left. Pressure level varies across platforms. 🧼 Soap not provided.",
  },
  {
    "web-scraper-order": "1666026003-993",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🪠 Plunger",
    "objects-href": "https://emojipedia.org/plunger/",
    emoji: "🪠",
    emojiName: "🪠 Plunger",
    description:
      "A toilet plunger with a wooden handle and red flange and cup.",
  },
  {
    "web-scraper-order": "1666026006-996",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🚽 Toilet",
    "objects-href": "https://emojipedia.org/toilet/",
    emoji: "🚽",
    emojiName: "🚽 Toilet",
    description:
      "A white toilet, as used to deposit a 💩 Pile of Poo. (Don’t forget the 🧻 Roll of Paper.) Most platforms depict a porcelain toilet in profile, bowl facing to the left.",
  },
  {
    "web-scraper-order": "1666026008-998",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🪑 Chair",
    "objects-href": "https://emojipedia.org/chair/",
    emoji: "🪑",
    emojiName: "🪑 Chair",
    description: "A simple wooden chair.",
  },
  {
    "web-scraper-order": "1666026010-1001",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🛋️ Couch and Lamp",
    "objects-href": "https://emojipedia.org/couch-and-lamp/",
    emoji: "🛋️",
    emojiName: "🛋️ Couch and Lamp",
    description:
      "A couch (sofa) with a floor lamp on the right, as in the living room of a house. Color and style of the couch and lamp vary widely by platform. Used for various content concerning furniture and housing as well as resting and lounging.",
  },
  {
    "web-scraper-order": "1666026013-1003",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🛏️ Bed",
    "objects-href": "https://emojipedia.org/bed/",
    emoji: "🛏️",
    emojiName: "🛏️ Bed",
    description:
      "A bed, made up for sleeping in a house, hotel, or other sleeping accommodation. Shown with a headboard at the left, footboard, mattress, pillow, and sheet. Most platforms suggest a wooden frame and feature blue or red sheets.",
  },
  {
    "web-scraper-order": "1666026015-1005",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🪟 Window",
    "objects-href": "https://emojipedia.org/window/",
    emoji: "🪟",
    emojiName: "🪟 Window",
    description:
      "A square or rectangular window with glass panes. Most platforms show a wooden frame with two or four panels.",
  },
  {
    "web-scraper-order": "1666026017-1008",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🪞 Mirror",
    "objects-href": "https://emojipedia.org/mirror/",
    emoji: "🪞",
    emojiName: "🪞 Mirror",
    description:
      "A mirror with an ornate gold or silver frame. The shape and style of the mirror varies from platform to platform.",
  },
  {
    "web-scraper-order": "1666026020-1010",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🚪 Door",
    "objects-href": "https://emojipedia.org/door/",
    emoji: "🚪",
    emojiName: "🚪 Door",
    description:
      "A door, as to the entrance of a room, house, or new opportunity. (We’ll see ourselves out 🚪🚶) Depicted in brown, as made of wood, with a gold handle.",
  },
  {
    "web-scraper-order": "1666026022-1012",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🩺 Stethoscope",
    "objects-href": "https://emojipedia.org/stethoscope/",
    emoji: "🩺",
    emojiName: "🩺 Stethoscope",
    description:
      "A stethoscope with a round resonator and two earpieces. Shown in black, blue, green, or red, depending on the platform.",
  },
  {
    "web-scraper-order": "1666026025-1015",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🩼 Crutch",
    "objects-href": "https://emojipedia.org/crutch/",
    emoji: "🩼",
    emojiName: "🩼 Crutch",
    description: "A basic crutch made of metal and rubber.",
  },
  {
    "web-scraper-order": "1666026028-1017",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🩹 Adhesive Bandage",
    "objects-href": "https://emojipedia.org/adhesive-bandage/",
    emoji: "🩹",
    emojiName: "🩹 Adhesive Bandage",
    description:
      "An adhesive bandage used for first aid. Sometimes called a Band-Aid or band aid after the trademarked product. Sometimes called a plaster.",
  },
  {
    "web-scraper-order": "1666026031-1020",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "💊 Pill",
    "objects-href": "https://emojipedia.org/pill/",
    emoji: "💊",
    emojiName: "💊 Pill",
    description:
      "A capsule of medicine. Generally depicted at a 45° angle, half red, half yellow. Commonly used for content concerning health, medicine, and related professions as well various types of drugs.",
  },
  {
    "web-scraper-order": "1666026033-1021",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🩸 Drop of Blood",
    "objects-href": "https://emojipedia.org/drop-of-blood/",
    emoji: "🩸",
    emojiName: "🩸 Drop of Blood",
    description:
      "A red drop of blood. May be used to talk about bleeding, injury, blood donation, or menstruation.",
  },
  {
    "web-scraper-order": "1666026035-1024",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "💉 Syringe",
    "objects-href": "https://emojipedia.org/syringe/",
    emoji: "💉",
    emojiName: "💉 Syringe",
    description:
      "A medical syringe, as used to administer a vaccine or draw blood. Generally depicted at a 45° angle with a needle to the upper right.",
  },
  {
    "web-scraper-order": "1666026038-1026",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📡 Satellite Antenna",
    "objects-href": "https://emojipedia.org/satellite-antenna/",
    emoji: "📡",
    emojiName: "📡 Satellite Antenna",
    description:
      "A dish antenna, as used to send or receive information to or from a communication satellite—or 👽 Extraterrestrial Life. Generally depicted as a mounted, metal dish with its antenna positioned at 45° to the upper right.",
  },
  {
    "web-scraper-order": "1666026040-1029",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🔭 Telescope",
    "objects-href": "https://emojipedia.org/telescope/",
    emoji: "🔭",
    emojiName: "🔭 Telescope",
    description:
      "A telescope, as used to gaze at stars and planets in the night sky. Shown with an optical tube mounted on a tripod, positioned at various angles and generally depicted as metal.",
  },
  {
    "web-scraper-order": "1666026043-1031",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🔬 Microscope",
    "objects-href": "https://emojipedia.org/microscope/",
    emoji: "🔬",
    emojiName: "🔬 Microscope",
    description:
      "A microscope, as used in science laboratories to magnify small objects, such as cells or insects. Depicted as a compound opitical microscope with an adjustable eyepiece, lens, arm, and slide stage mounted on a base. Generally shown as metal with the viewing apparatus facing left.",
  },
  {
    "web-scraper-order": "1666026045-1033",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🧬 DNA",
    "objects-href": "https://emojipedia.org/dna/",
    emoji: "🧬",
    emojiName: "🧬 DNA",
    description:
      "The double helix of DNA, the genetic blueprint for life. Color and orientation vary across platforms, but positioned at a 45° angle and in multiple, bright colors to represent the molecule’s spiraling, ladder-like structure.",
  },
  {
    "web-scraper-order": "1666026048-1035",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🧫 Petri Dish",
    "objects-href": "https://emojipedia.org/petri-dish/",
    emoji: "🧫",
    emojiName: "🧫 Petri Dish",
    description:
      "A petri dish, as used to culture microbes. Depicted as a clear, shallow cylinder with a red, blue, or green growth medium, such as agar, with splotches of variously colored cells, like bacteria.",
  },
  {
    "web-scraper-order": "1666026050-1037",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🧪 Test Tube",
    "objects-href": "https://emojipedia.org/test-tube/",
    emoji: "🧪",
    emojiName: "🧪 Test Tube",
    description:
      "A test tube, as used to conduct chemical experiments in a laboratory. Depicted as a clear cylinder, open at one end and containing a green liquid. Positioned at a 45° angle.",
  },
  {
    "web-scraper-order": "1666026052-1038",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "⚗️ Alembic",
    "objects-href": "https://emojipedia.org/alembic/",
    emoji: "⚗️",
    emojiName: "⚗️ Alembic",
    description:
      "An apparatus for distilling, as used in medieval alchemy. Generally depicted as a round flask with a neck angled down to the right. Positioned on a short stand and containing a mysterious green, purple, or blue liquid.",
  },
  {
    "web-scraper-order": "1666026055-1040",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🪜 Ladder",
    "objects-href": "https://emojipedia.org/ladder/",
    emoji: "🪜",
    emojiName: "🪜 Ladder",
    description: "A wooden ladder with four or five rungs.",
  },
  {
    "web-scraper-order": "1666026057-1042",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🧲 Magnet",
    "objects-href": "https://emojipedia.org/magnet/",
    emoji: "🧲",
    emojiName: "🧲 Magnet",
    description:
      "A horseshoe magnet, as used to pick up iron. Depicted at various angles in red with silver-tipped poles.",
  },
  {
    "web-scraper-order": "1666026059-1043",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🧰 Toolbox",
    "objects-href": "https://emojipedia.org/toolbox/",
    emoji: "🧰",
    emojiName: "🧰 Toolbox",
    description:
      "A red box for holding and transporting tools, such as a hammer and wrench. Generally depicted as latched shut with silver hardware and a black handle.",
  },
  {
    "web-scraper-order": "1666026062-1045",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🪝 Hook",
    "objects-href": "https://emojipedia.org/hook/",
    emoji: "🪝",
    emojiName: "🪝 Hook",
    description:
      "A gold or silver hook. Can be used to represent literal hooks like the kinds you use to crochet or catch fish.",
  },
  {
    "web-scraper-order": "1666026064-1046",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "⛓️ Chains",
    "objects-href": "https://emojipedia.org/chains/",
    emoji: "⛓️",
    emojiName: "⛓️ Chains",
    description:
      "Two parallel lengths of silver chain. Occasionally used as an icon before a hyperlink or for metaphorical connections or chains, e.g., slang off the chains.",
  },
  {
    "web-scraper-order": "1666026067-1048",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🔗 Link",
    "objects-href": "https://emojipedia.org/link/",
    emoji: "🔗",
    emojiName: "🔗 Link",
    description:
      "Two links of a silver chain, positioned at a 45° angle. Used as an icon for a hyperlink on computers and the internet. May also be used for metaphorical connections.",
  },
  {
    "web-scraper-order": "1666026070-1050",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🦯 White Cane",
    "objects-href": "https://emojipedia.org/white-cane/",
    emoji: "🦯",
    emojiName: "🦯 White Cane",
    description:
      "A white cane, used by some people who are blind or visually impaired. The cane has a black or gray handle with a wrist loop, a white middle section, and a red end with a white cap. This cane differs from a support cane and is sometimes called a probing cane.",
  },
  {
    "web-scraper-order": "1666026072-1051",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "⚖️ Balance Scale",
    "objects-href": "https://emojipedia.org/balance-scale/",
    emoji: "⚖️",
    emojiName: "⚖️ Balance Scale",
    description:
      "A balance scale, as historically used to measure weight. A symbol of justice, as held by Lady Justice, and of the zodiac sign of Libra, the Scales. Depicted as two silver or gold pans suspended from a beam and supported on a base.",
  },
  {
    "web-scraper-order": "1666026075-1053",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🗜️ Clamp",
    "objects-href": "https://emojipedia.org/clamp/",
    emoji: "🗜️",
    emojiName: "🗜️ Clamp",
    description:
      "A metal clamp or vice, as screwed to hold or compress materials like wood or metal. Depicted as a C-clamp or F-clamp, its screw in various positions.",
  },
  {
    "web-scraper-order": "1666026078-1055",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "⚙️ Gear",
    "objects-href": "https://emojipedia.org/gear/",
    emoji: "⚙️",
    emojiName: "⚙️ Gear",
    description: "A round metal gear with teeth.",
  },
  {
    "web-scraper-order": "1666026080-1056",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🔩 Nut and Bolt",
    "objects-href": "https://emojipedia.org/nut-and-bolt/",
    emoji: "🔩",
    emojiName: "🔩 Nut and Bolt",
    description:
      "A metal bolt with a nut threaded around it, as by a wrench. Often positioned at a 45° angle, the head of the bolt at the upper left. Commonly used for various content concerning tools, building, and construction. May also be used for other hardware, including screws.",
  },
  {
    "web-scraper-order": "1666026083-1058",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🪛 Screwdriver",
    "objects-href": "https://emojipedia.org/screwdriver/",
    emoji: "🪛",
    emojiName: "🪛 Screwdriver",
    description:
      "A silver Phillips-head or slotted-head screwdriver with a colorful handle. Most platforms show a red handle, though Apple's design has a green handle. Used to represent construction, building, carpentry, renovation, or tools in general.",
  },
  {
    "web-scraper-order": "1666026085-1060",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🔧 Wrench",
    "objects-href": "https://emojipedia.org/wrench/",
    emoji: "🔧",
    emojiName: "🔧 Wrench",
    description:
      "A metal wrench (spanner), as used for turning nuts and bolts. Depicted with two open, crescent-shaped ends or one open end and a closed, ring-shaped end. Generally positioned at a 45° angle.",
  },
  {
    "web-scraper-order": "1666026088-1062",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🪚 Carpentry Saw",
    "objects-href": "https://emojipedia.org/carpentry-saw/",
    emoji: "🪚",
    emojiName: "🪚 Carpentry Saw",
    description:
      "A long silver saw with a wooden handle. Used to represent construction, carpentry, renovation, or tools in general.",
  },
  {
    "web-scraper-order": "1666026090-1064",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🛡️ Shield",
    "objects-href": "https://emojipedia.org/shield/",
    emoji: "🛡️",
    emojiName: "🛡️ Shield",
    description:
      "A shield, as blocks swords in close combat. Color and style varies across platforms, but generally depicted in a kite shape with a metal border and simple pattern.",
  },
  {
    "web-scraper-order": "1666026093-1065",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🪃 Boomerang",
    "objects-href": "https://emojipedia.org/boomerang/",
    emoji: "🪃",
    emojiName: "🪃 Boomerang",
    description:
      "A wooden boomerang with bright colors on its tips. Google and Twitter's designs show motion lines to illustrate the path of a boomerang.",
  },
  {
    "web-scraper-order": "1666026095-1067",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🔫 Water Pistol",
    "objects-href": "https://emojipedia.org/pistol/",
    emoji: "🔫",
    emojiName: "🔫 Water Pistol",
    description: "A squirt gun (water pistol), as used to spray water for fun.",
  },
  {
    "web-scraper-order": "1666026097-1069",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "⚔️ Crossed Swords",
    "objects-href": "https://emojipedia.org/crossed-swords/",
    emoji: "⚔️",
    emojiName: "⚔️ Crossed Swords",
    description:
      "Two swords with steel blades in an X shape, as crossed for combat between two knights or warriors. Generally depicted as straight, double-edged blades with brown or black, cross-shaped hilts, points directed up. Commonly used as a symbol for battle, fighting, or a contest, as in sports.",
  },
  {
    "web-scraper-order": "1666026100-1071",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🗡️ Dagger",
    "objects-href": "https://emojipedia.org/dagger/",
    emoji: "🗡️",
    emojiName: "🗡️ Dagger",
    description:
      "A pointed knife with a steel blade, as used for thrusting in close combat. Generally depicted as double-edged with a black, brown or gold cross-shaped hilt and positioned at 45° angle, often with its tip at the lower left.",
  },
  {
    "web-scraper-order": "1666026102-1073",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🛠️ Hammer and Wrench",
    "objects-href": "https://emojipedia.org/hammer-and-wrench/",
    emoji: "🛠️",
    emojiName: "🛠️ Hammer and Wrench",
    description:
      "A hammer and wrench, as kept in a toolbox, crossed in an X shape. Depicted with metal tools facing up, the hammer positioned at the upper left. Most vendors implement the same design as for their 🔨 Hammer and 🔧 Wrench.",
  },
  {
    "web-scraper-order": "1666026106-1075",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "⚒️ Hammer and Pick",
    "objects-href": "https://emojipedia.org/hammer-and-pick/",
    emoji: "⚒️",
    emojiName: "⚒️ Hammer and Pick",
    description:
      "A hammer and pick, as used for breaking up rocks in mining, crossed in an X shape. Generally depicted as metal, mallet- and chisel-styled hammers with wooden handles. The heads of the tools face up, with the pick usually at the right. Often used for various content concerning tools, building, and construction.",
  },
  {
    "web-scraper-order": "1666026108-1077",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "⛏️ Pick",
    "objects-href": "https://emojipedia.org/pick/",
    emoji: "⛏️",
    emojiName: "⛏️ Pick",
    description:
      "A pickaxe, a tool with a curved spike for breaking up rocks in mining. Generally depicted with a metal head and wooden handle, positioned at a 45° angle with the head at the upper left.",
  },
  {
    "web-scraper-order": "1666026111-1079",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🪓 Axe",
    "objects-href": "https://emojipedia.org/axe/",
    emoji: "🪓",
    emojiName: "🪓 Axe",
    description:
      "An axe with a wooden handle and a metal blade. On many platforms the blade is red, like a fire axe.",
  },
  {
    "web-scraper-order": "1666026113-1080",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🔨 Hammer",
    "objects-href": "https://emojipedia.org/hammer/",
    emoji: "🔨",
    emojiName: "🔨 Hammer",
    description:
      "A claw hammer, as used for driving or removing nails. Generally depicted with a metal head and wooden handle, positioned at a 45° angle with the head at the upper left.",
  },
  {
    "web-scraper-order": "1666026115-1082",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🗝️ Old Key",
    "objects-href": "https://emojipedia.org/old-key/",
    emoji: "🗝️",
    emojiName: "🗝️ Old Key",
    description:
      "An old-fashioned key, as opens an antique chest or wardrobe. Generally depicted at a 45° angle as a tarnished, silver skeleton key with an ornate, bowed head and two-toothed bit at the bottom left.",
  },
  {
    "web-scraper-order": "1666026118-1083",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🔑 Key",
    "objects-href": "https://emojipedia.org/key/",
    emoji: "🔑",
    emojiName: "🔑 Key",
    description:
      'A key, as opens a door or lock. Depicted at a 45° angle as a gold, bronze, or copper key with a round head and notched blade. Commonly used for figurative senses of key, e.g., the key to success, being key ("crucial").',
  },
  {
    "web-scraper-order": "1666026120-1085",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🔐 Locked with Key",
    "objects-href": "https://emojipedia.org/locked-with-key/",
    emoji: "🔐",
    emojiName: "🔐 Locked with Key",
    description:
      "A locked (closed) padlock with an upright key at its right. Vendors implement the same designs as their 🔒 Locked and 🔑 Key.",
  },
  {
    "web-scraper-order": "1666026122-1087",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🔏 Locked with Pen",
    "objects-href": "https://emojipedia.org/locked-with-pen/",
    emoji: "🔏",
    emojiName: "🔏 Locked with Pen",
    description:
      "A locked (closed) padlock with a fountain pen or nib positioned at various angles in front of it. Vendors implement the same design as their 🔒 Locked and the same or similar design as their 🖋️ Fountain Pen or ✒️ Black Nib.",
  },
  {
    "web-scraper-order": "1666026125-1089",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🔓 Unlocked",
    "objects-href": "https://emojipedia.org/unlocked/",
    emoji: "🔓",
    emojiName: "🔓 Unlocked",
    description:
      "An unlocked padlock, as used to secure a latch or chain, or as an icon for a non-secure connection or open access online. Generally depicted with a gold base and silver shackle, as an open 🔒 Locked.",
  },
  {
    "web-scraper-order": "1666026127-1091",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🔒 Locked",
    "objects-href": "https://emojipedia.org/locked/",
    emoji: "🔒",
    emojiName: "🔒 Locked",
    description:
      "A locked (closed) padlock, as used to secure a latch or chain, or as an icon for a secure internet connection, private account, or locked device. Generally depicted with a gold base and silver shackle. WhatsApp’s design is silver.",
  },
  {
    "web-scraper-order": "1666026130-1093",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🗑️ Wastebasket",
    "objects-href": "https://emojipedia.org/wastebasket/",
    emoji: "🗑️",
    emojiName: "🗑️ Wastebasket",
    description:
      "A wastebasket, as used to discard trash in an office. Generally depicted as a silver, wire-mesh container. Also known as a wastepaper basket, trash/garbage can, or rubbish bin.",
  },
  {
    "web-scraper-order": "1666026132-1095",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🗄️ File Cabinet",
    "objects-href": "https://emojipedia.org/file-cabinet/",
    emoji: "🗄️",
    emojiName: "🗄️ File Cabinet",
    description:
      "A metal filing cabinet, as used to organize and store file folders at an office. Depicted in black or gray with two drawers, handles, and label holders.",
  },
  {
    "web-scraper-order": "1666026134-1097",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🗃️ Card File Box",
    "objects-href": "https://emojipedia.org/card-file-box/",
    emoji: "🗃️",
    emojiName: "🗃️ Card File Box",
    description:
      "A black or gray box with a label holder, containing card index dividers with multicolored tabs, as used to organize and store files. Apple and Facebook’s designs include a lid.",
  },
  {
    "web-scraper-order": "1666026137-1099",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "✂️ Scissors",
    "objects-href": "https://emojipedia.org/scissors/",
    emoji: "✂️",
    emojiName: "✂️ Scissors",
    description:
      "A pair of scissors, as used to cut paper or hair. Generally shown open, blades down, with red handles. Commonly used for content concerning haircuts, fashion design, arts and crafts, and various senses of cutting.",
  },
  {
    "web-scraper-order": "1666026140-1101",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📐 Triangular Ruler",
    "objects-href": "https://emojipedia.org/triangular-ruler/",
    emoji: "📐",
    emojiName: "📐 Triangular Ruler",
    description:
      "A triangle or set square, as used by engineers or architects to draw straight lines at angles. Variously depicted as a metal, wood, or plastic right triangle with length markings, its hypotenuse to the right.",
  },
  {
    "web-scraper-order": "1666026142-1103",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📏 Straight Ruler",
    "objects-href": "https://emojipedia.org/straight-ruler/",
    emoji: "📏",
    emojiName: "📏 Straight Ruler",
    description:
      "A ruler, as used to draw straight lines and measure distances. Variously depicted as a metal, wood, or plastic straightedge with length markings at a 45° angle.",
  },
  {
    "web-scraper-order": "1666026145-1105",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🖇️ Linked Paperclips",
    "objects-href": "https://emojipedia.org/linked-paperclips/",
    emoji: "🖇️",
    emojiName: "🖇️ Linked Paperclips",
    description:
      "Two or more silver paper clips linked together, generally forming an inverted V. Microsoft’s design displays three paper clips.",
  },
  {
    "web-scraper-order": "1666026147-1107",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📎 Paperclip",
    "objects-href": "https://emojipedia.org/paperclip/",
    emoji: "📎",
    emojiName: "📎 Paperclip",
    description:
      "A silver paper clip, as used to hold together sheets of paper—or remove a SIM card from a mobile phone. Shown positioned at various angles.",
  },
  {
    "web-scraper-order": "1666026150-1109",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📍 Round Pushpin",
    "objects-href": "https://emojipedia.org/round-pushpin/",
    emoji: "📍",
    emojiName: "📍 Round Pushpin",
    description:
      "A pushpin, as used to indicate a location on a map. Generally depicted as an upright pin with a red, round head.",
  },
  {
    "web-scraper-order": "1666026152-1111",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📌 Pushpin",
    "objects-href": "https://emojipedia.org/pushpin/",
    emoji: "📌",
    emojiName: "📌 Pushpin",
    description:
      "A thumbtack (drawing pin), as used to pin documents on a bulletin (notice) board. Depicted at a 45° angle with its red, flat head to the upper right.",
  },
  {
    "web-scraper-order": "1666026154-1113",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📋 Clipboard",
    "objects-href": "https://emojipedia.org/clipboard/",
    emoji: "📋",
    emojiName: "📋 Clipboard",
    description:
      "A white piece of paper secured by a silver clip on a brown clipboard, as used as a writing surface when standing. Commonly used for content concerning various types of documents and writing, especially in sports.",
  },
  {
    "web-scraper-order": "1666026157-1115",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📊 Bar Chart",
    "objects-href": "https://emojipedia.org/bar-chart/",
    emoji: "📊",
    emojiName: "📊 Bar Chart",
    description:
      "A bar graph generally showing three different-colored, vertical rectangles at various heights, as compares values across a category. Commonly used to represent various types of data, information, facts, figures, and charts more generally.",
  },
  {
    "web-scraper-order": "1666026159-1117",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📉 Chart Decreasing",
    "objects-href": "https://emojipedia.org/chart-decreasing/",
    emoji: "📉",
    emojiName: "📉 Chart Decreasing",
    description:
      "A graph showing a colored trend line, often blue, decreasing over time, as stock prices or revenues. Commonly used to represent various types of decrease, from numeral data to being metaphorically down. May also represent facts, figures, and charts more generally.",
  },
  {
    "web-scraper-order": "1666026161-1119",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📈 Chart Increasing",
    "objects-href": "https://emojipedia.org/chart-increasing/",
    emoji: "📈",
    emojiName: "📈 Chart Increasing",
    description:
      "A graph showing a red (or sometimes green) trend line increasing over time, as stock prices or revenues. Commonly used to represent various types of increase, from numerical data to being metaphorically on the rise. May also represent trending content as well as facts, figures, and charts more generally.",
  },
  {
    "web-scraper-order": "1666026164-1121",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📇 Card Index",
    "objects-href": "https://emojipedia.org/card-index/",
    emoji: "📇",
    emojiName: "📇 Card Index",
    description:
      "A card index, as a Rolodex, once used to organize and access cards containing the information of personal or business contacts. Depicted as a black or gray rotating device with a contact card displayed, including a graphic and text.",
  },
  {
    "web-scraper-order": "1666026168-1123",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🗓️ Spiral Calendar",
    "objects-href": "https://emojipedia.org/spiral-calendar/",
    emoji: "🗓️",
    emojiName: "🗓️ Spiral Calendar",
    description:
      "A spiral-bound calendar. Generally depicted as a monthly calendar, with a red or blue header. Apple and Samsung’s pages are curled up at the bottom right, as to flip for a new month.",
  },
  {
    "web-scraper-order": "1666026170-1125",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🗒️ Spiral Notepad",
    "objects-href": "https://emojipedia.org/spiral-notepad/",
    emoji: "🗒️",
    emojiName: "🗒️ Spiral Notepad",
    description:
      "A spiral-bound, flip-style notepad or notebook of lined paper, as used for everyday note-taking. Commonly used for content concerning various types of documents and writing.",
  },
  {
    "web-scraper-order": "1666026173-1127",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📆 Tear-Off Calendar",
    "objects-href": "https://emojipedia.org/tear-off-calendar/",
    emoji: "📆",
    emojiName: "📆 Tear-Off Calendar",
    description:
      "A single date on a calendar. Generally depicted as a page on a two-ringed, daily desk calendar, as flipped or torn off to change the date. Displays month and day on a white, square page, curled up at the bottom right.",
  },
  {
    "web-scraper-order": "1666026175-1129",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📅 Calendar",
    "objects-href": "https://emojipedia.org/calendar/",
    emoji: "📅",
    emojiName: "📅 Calendar",
    description:
      "A single date on a calendar. Generally depicted as a page torn off from a daily desk calendar, displaying month and day on a white, square page.",
  },
  {
    "web-scraper-order": "1666026177-1132",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🗂️ Card Index Dividers",
    "objects-href": "https://emojipedia.org/card-index-dividers/",
    emoji: "🗂️",
    emojiName: "🗂️ Card Index Dividers",
    description:
      "A set of tabbed dividers or file guides, as used to organize a card index or file box. Depicted with three or more multicolored tabs on manila paper.",
  },
  {
    "web-scraper-order": "1666026180-1134",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📂 Open File Folder",
    "objects-href": "https://emojipedia.org/open-file-folder/",
    emoji: "📂",
    emojiName: "📂 Open File Folder",
    description:
      "A slightly open tabbed folder, as used to file papers in a cabinet or as an icon for an opened folder when using a computer. Most platforms depict a yellow folder, as manila, with the tab shown at the left.",
  },
  {
    "web-scraper-order": "1666026182-1136",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📁 File Folder",
    "objects-href": "https://emojipedia.org/file-folder/",
    emoji: "📁",
    emojiName: "📁 File Folder",
    description:
      "A tabbed folder, as used to file papers in a cabinet or as an icon for a file on a computer. Most platforms depict a yellow folder, as manila, with the tab shown at the left.",
  },
  {
    "web-scraper-order": "1666026185-1138",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📝 Memo",
    "objects-href": "https://emojipedia.org/memo/",
    emoji: "📝",
    emojiName: "📝 Memo",
    description:
      "A white piece of paper with text written on it by a yellow pencil, positioned over the sheet, tip down, at a 45° angle. Commonly used for content concerning various types of documents and writing, including signing (in sports).",
  },
  {
    "web-scraper-order": "1666026188-1140",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🖍️ Crayon",
    "objects-href": "https://emojipedia.org/crayon/",
    emoji: "🖍️",
    emojiName: "🖍️ Crayon",
    description:
      "A crayon, as children use to color. Depicted as red on most platforms with two black stripes on its label, resembling a Crayola crayon. Positioned at a 45° angle, its tip at the lower left. Commonly used for various content concerning drawing, colors, arts and crafts, and schooling.",
  },
  {
    "web-scraper-order": "1666026190-1142",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🖌️ Paintbrush",
    "objects-href": "https://emojipedia.org/paintbrush/",
    emoji: "🖌️",
    emojiName: "🖌️ Paintbrush",
    description:
      "A thin, artist's paintbrush, as used to paint a picture. Often depicted with reddish paint on its pointed bristles. Positioned at a 45° angle, its tip at the lower left.",
  },
  {
    "web-scraper-order": "1666026192-1144",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🖊️ Pen",
    "objects-href": "https://emojipedia.org/pen/",
    emoji: "🖊️",
    emojiName: "🖊️ Pen",
    description:
      "A blue or black ballpoint pen, as used for everyday writing. Depicted with its cap removed onto its end or as retractable pen. Positioned at a 45° angle, its tip at the lower left. Commonly used for various content concerning writing (e.g., creative, professional) as well as signing (deals, laws, in sports).",
  },
  {
    "web-scraper-order": "1666026194-1146",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🖋️ Fountain Pen",
    "objects-href": "https://emojipedia.org/fountain-pen/",
    emoji: "🖋️",
    emojiName: "🖋️ Fountain Pen",
    description:
      "A black fountain pen with a silver nib, as used for signing important documents. Often depicted with gold hardware. Positioned at a 45° angle with its tip at the lower left. Like ✒️ Black Nib, commonly used for various content concerning writing, drawing, and signing (e.g., laws, deals, in sports).",
  },
  {
    "web-scraper-order": "1666026197-1148",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "✒️ Black Nib",
    "objects-href": "https://emojipedia.org/black-nib/",
    emoji: "✒️",
    emojiName: "✒️ Black Nib",
    description:
      "The silver nib of a fountain pen, which distributes ink onto a writing surface. Positioned at a 45° angle, with its tip at the lower left or right. Like 🖋️ Fountain Pen, commonly used for various content concerning writing, drawing, and signing (e.g., laws, deals, in sports).",
  },
  {
    "web-scraper-order": "1666026200-1150",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "✏️ Pencil",
    "objects-href": "https://emojipedia.org/pencil/",
    emoji: "✏️",
    emojiName: "✏️ Pencil",
    description:
      "A classic yellow pencil. Depicted as a graphite pencil, like a U.S. #2 or European HB, with a sharpened tip and pink eraser. Positioned at a 45° angle, with its tip at the lower left or right. Commonly used for various content concerning writing, drawing, and schooling.",
  },
  {
    "web-scraper-order": "1666026202-1152",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🗳️ Ballot Box with Ballot",
    "objects-href": "https://emojipedia.org/ballot-box-with-ballot/",
    emoji: "🗳️",
    emojiName: "🗳️ Ballot Box with Ballot",
    description:
      "A ballot box, as used to cast votes in an election. Depicted as a box, generally blue or gray, with a slot on top through which a paper ballot is being inserted. Many platforms display a cross mark or check mark on the ballot to indicate a vote, though Apple and Facebook leave theirs blank.",
  },
  {
    "web-scraper-order": "1666026206-1154",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📮 Postbox",
    "objects-href": "https://emojipedia.org/postbox/",
    emoji: "📮",
    emojiName: "📮 Postbox",
    description:
      "A postbox (mailbox, letterbox) with a letter in its slot for collection. Generally depicted in red with a white envelope, styled after public postboxes in Japan. May also evoke postboxes in the United Kingdom.",
  },
  {
    "web-scraper-order": "1666026208-1156",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📭 Open Mailbox with Lowered Flag",
    "objects-href": "https://emojipedia.org/open-mailbox-with-lowered-flag/",
    emoji: "📭",
    emojiName: "📭 Open Mailbox with Lowered Flag",
    description:
      "A curbside mailbox (letterbox, postbox) with its signal flag lowered and its slot empty. Generally depicted in blue or gray with a red flag. Used for various content concerning postal deliveries and email.",
  },
  {
    "web-scraper-order": "1666026211-1158",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📬 Open Mailbox with Raised Flag",
    "objects-href": "https://emojipedia.org/open-mailbox-with-raised-flag/",
    emoji: "📬",
    emojiName: "📬 Open Mailbox with Raised Flag",
    description:
      "An open, curbside mailbox (letterbox, postbox) with its signal flag raised and a letter in its open slot. Generally depicted in blue or gray with a red flag and white envelope, though Google's envelope was previously yellow. Used for various content concerning postal deliveries and email.",
  },
  {
    "web-scraper-order": "1666026214-1160",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📪 Closed Mailbox with Lowered Flag",
    "objects-href": "https://emojipedia.org/closed-mailbox-with-lowered-flag/",
    emoji: "📪",
    emojiName: "📪 Closed Mailbox with Lowered Flag",
    description:
      "A curbside mailbox (letterbox, postbox) with its door latched shut and signal flag lowered. Generally depicted in blue or gray with a red flag. Used for various content concerning postal deliveries and email.",
  },
  {
    "web-scraper-order": "1666026216-1162",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📫 Closed Mailbox with Raised Flag",
    "objects-href": "https://emojipedia.org/closed-mailbox-with-raised-flag/",
    emoji: "📫",
    emojiName: "📫 Closed Mailbox with Raised Flag",
    description:
      "A curbside mailbox (letterbox, postbox) with its door latched shut and signal flag raised. Generally depicted in blue or gray with a red flag. Used for various content concerning postal deliveries and email.",
  },
  {
    "web-scraper-order": "1666026219-1164",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📦 Package",
    "objects-href": "https://emojipedia.org/package/",
    emoji: "📦",
    emojiName: "📦 Package",
    description:
      "A package (parcel), as contains items ordered online. Depicted at various angles as a light-brown, cardboard box, with a shipping label and its top taped shut.",
  },
  {
    "web-scraper-order": "1666026221-1166",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📥 Inbox Tray",
    "objects-href": "https://emojipedia.org/inbox-tray/",
    emoji: "📥",
    emojiName: "📥 Inbox Tray",
    description:
      "A paper tray with a down arrow on top, as a symbol for an email inbox. Generally depicted as a white or wooden try with a red arrow. Samsung and Twitter's arrows are green, WhatsApp's gray.",
  },
  {
    "web-scraper-order": "1666026223-1168",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📤 Outbox Tray",
    "objects-href": "https://emojipedia.org/outbox-tray/",
    emoji: "📤",
    emojiName: "📤 Outbox Tray",
    description:
      "A paper tray with an up arrow on top, as a symbol for an email outbox. Generally depicted as a white or wooden tray with a red arrow pointing upwards. Facebook's design contains paper.",
  },
  {
    "web-scraper-order": "1666026226-1170",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📩 Envelope with Arrow",
    "objects-href": "https://emojipedia.org/envelope-with-arrow/",
    emoji: "📩",
    emojiName: "📩 Envelope with Arrow",
    description:
      "The back of envelope with a down arrow on top. Generally depicted in white with a red or blue arrow.",
  },
  {
    "web-scraper-order": "1666026229-1172",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📨 Incoming Envelope",
    "objects-href": "https://emojipedia.org/incoming-envelope/",
    emoji: "📨",
    emojiName: "📨 Incoming Envelope",
    description:
      "The back of an envelope, shown coming into an inbox or arriving with motion lines.",
  },
  {
    "web-scraper-order": "1666026231-1174",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📧 E-Mail",
    "objects-href": "https://emojipedia.org/e-mail/",
    emoji: "📧",
    emojiName: "📧 E-Mail",
    description:
      "A symbol for email. Depicted as the back of an envelope imprinted with a capital letter E (for electronic) or @ (at) sign. Commonly used as an icon before an email address.",
  },
  {
    "web-scraper-order": "1666026233-1176",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "✉️ Envelope",
    "objects-href": "https://emojipedia.org/envelope/",
    emoji: "✉️",
    emojiName: "✉️ Envelope",
    description:
      "The back of a white envelope, as used to send a letter or card in the mail (post). Used for various content concerning mail and messages, including email.",
  },
  {
    "web-scraper-order": "1666026236-1178",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🧾 Receipt",
    "objects-href": "https://emojipedia.org/receipt/",
    emoji: "🧾",
    emojiName: "🧾 Receipt",
    description:
      'A white paper receipt, as proof of payment, and shown flat or curled. May be used for other financial documents (e.g., invoice, tax form). May also be used for the slang receipts, or "evidence” or “confirmation” of some feat or controversy.',
  },
  {
    "web-scraper-order": "1666026238-1180",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "💳 Credit Card",
    "objects-href": "https://emojipedia.org/credit-card/",
    emoji: "💳",
    emojiName: "💳 Credit Card",
    description:
      "The backside of a credit card, showing the magnetic strip and signature. Color and detail vary across platforms, but often shown as gold, silver, or blue. May be used for banking and other ID cards as well for various content concerning money, including payment.",
  },
  {
    "web-scraper-order": "1666026241-1182",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "💸 Money with Wings",
    "objects-href": "https://emojipedia.org/money-with-wings/",
    emoji: "💸",
    emojiName: "💸 Money with Wings",
    description:
      "A banded stack of U.S. dollar bills with feather wings, as if flying. Its flight may represent losing, transferring, or earning money, but commonly used for wealth, money, and success more generally, often with a flourish or sense of flair.",
  },
  {
    "web-scraper-order": "1666026244-1184",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "💷 Pound Banknote",
    "objects-href": "https://emojipedia.org/pound-banknote/",
    emoji: "💷",
    emojiName: "💷 Pound Banknote",
    description:
      "Quids in! A banded stack of pound banknotes, the paper currency of the United Kingdom (England, Wales, Northern Ireland, and Scotland). Color and detail vary across platforms, but widely depicted as purple £20 notes with the pound sign, £.",
  },
  {
    "web-scraper-order": "1666026246-1186",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "💶 Euro Banknote",
    "objects-href": "https://emojipedia.org/euro-banknote/",
    emoji: "💶",
    emojiName: "💶 Euro Banknote",
    description:
      "A banded stack of euro banknotes, the paper currency of the European Union (EU). Color and detail vary across platforms, but shown with the euro sign, €. Commonly used for various content concerning wealth and money, not restricted to the EU.",
  },
  {
    "web-scraper-order": "1666026248-1188",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "💵 Dollar Banknote",
    "objects-href": "https://emojipedia.org/dollar-banknote/",
    emoji: "💵",
    emojiName: "💵 Dollar Banknote",
    description:
      "Cash money! A banded stack of U.S. dollar banknotes, the paper currency of the United States of America. Green hue and detail vary across platforms, but shown with the dollar sign, $. Commonly used for various content concerning wealth and money, not restricted to the U.S.",
  },
  {
    "web-scraper-order": "1666026250-1190",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "💴 Yen Banknote",
    "objects-href": "https://emojipedia.org/yen-banknote/",
    emoji: "💴",
    emojiName: "💴 Yen Banknote",
    description:
      "A banded stack of yen banknotes, the paper currency of Japan. Color and detail vary across platforms, but usually shown in green, yellow, or pink with the yen symbol, ¥. Commonly used for various content concerning money and wealth, not restricted to Japan.",
  },
  {
    "web-scraper-order": "1666026253-1191",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🪙 Coin",
    "objects-href": "https://emojipedia.org/coin/",
    emoji: "🪙",
    emojiName: "🪙 Coin",
    description:
      "A coin shown in silver or gold. Design varies by platform, with Google and Twitter showing a 🏛️ Classical Building and Samsung showing the number one, similar to their 🥇 1st Place Medal design.",
  },
  {
    "web-scraper-order": "1666026255-1192",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "💰 Money Bag",
    "objects-href": "https://emojipedia.org/money-bag/",
    emoji: "💰",
    emojiName: "💰 Money Bag",
    description:
      "A bag full of money. Depicted as a sack, usually tan, tied off and displaying a dollar sign. May be filled with coins, as most platforms show a rounded bag.",
  },
  {
    "web-scraper-order": "1666026257-1193",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🏷️ Label",
    "objects-href": "https://emojipedia.org/label/",
    emoji: "🏷️",
    emojiName: "🏷️ Label",
    description:
      "A light-brown or yellow rectangular tag, as labelled and attached to a key. Depicted at various angles punched with a hole, generally with a metal ring or loop of string.",
  },
  {
    "web-scraper-order": "1666026260-1194",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🔖 Bookmark",
    "objects-href": "https://emojipedia.org/bookmark/",
    emoji: "🔖",
    emojiName: "🔖 Bookmark",
    description:
      "A bookmark, as used to mark one's place in a book. May also represent bookmarks on an internet browser. Appearance varies across platforms, but generally depicted at a 45° angle as a thin, white or red strip with a decorative tie and design, such as flower or star.",
  },
  {
    "web-scraper-order": "1666026263-1195",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📑 Bookmark Tabs",
    "objects-href": "https://emojipedia.org/bookmark-tabs/",
    emoji: "📑",
    emojiName: "📑 Bookmark Tabs",
    description:
      "Sheets of white, printed paper with variously colored tabs to bookmark important sections or indicate signature lines. Commonly used for content concerning various types of documents and writing.",
  },
  {
    "web-scraper-order": "1666026266-1196",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🗞️ Rolled-Up Newspaper",
    "objects-href": "https://emojipedia.org/rolled-up-newspaper/",
    emoji: "🗞️",
    emojiName: "🗞️ Rolled-Up Newspaper",
    description:
      "A newspaper rolled up and bound, as for delivery to a house. Generally positioned at a 45° angle. Commonly used for various content concerning news, media, and journalism as well as personal news.",
  },
  {
    "web-scraper-order": "1666026268-1197",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📰 Newspaper",
    "objects-href": "https://emojipedia.org/newspaper/",
    emoji: "📰",
    emojiName: "📰 Newspaper",
    description:
      "The front page of a newspaper, as people once read the news before the internet. Commonly used for various content concerning news, media, and journalism as well as personal news.",
  },
  {
    "web-scraper-order": "1666026270-1198",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📄 Page Facing Up",
    "objects-href": "https://emojipedia.org/page-facing-up/",
    emoji: "📄",
    emojiName: "📄 Page Facing Up",
    description:
      "A white piece of paper, its top right corner curled or dog-eared, with text printed on it, as a business letter or icon for a document on a computer. Commonly used for content concerning various types of documents and writing.",
  },
  {
    "web-scraper-order": "1666026273-1199",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📜 Scroll",
    "objects-href": "https://emojipedia.org/scroll/",
    emoji: "📜",
    emojiName: "📜 Scroll",
    description:
      "An ancient scroll, unrolled to reveal text on papyrus or parchment paper. May be used to represent the study of history or official documents, such as a diploma.",
  },
  {
    "web-scraper-order": "1666026275-1200",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📃 Page with Curl",
    "objects-href": "https://emojipedia.org/page-with-curl/",
    emoji: "📃",
    emojiName: "📃 Page with Curl",
    description:
      "A white piece of paper, curled up at the bottom to the left or right, with text printed on it, as a business letter. Commonly used for content concerning various types of documents and writing.",
  },
  {
    "web-scraper-order": "1666026278-1201",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📒 Ledger",
    "objects-href": "https://emojipedia.org/ledger/",
    emoji: "📒",
    emojiName: "📒 Ledger",
    description:
      "A spiral-bound, yellow, hardcover notebook. Intended to depict a financial ledger, as used in accounting.",
  },
  {
    "web-scraper-order": "1666026280-1202",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📓 Notebook",
    "objects-href": "https://emojipedia.org/notebook/",
    emoji: "📓",
    emojiName: "📓 Notebook",
    description:
      "A dark-colored, hardcover notebook, as used to write or take notes in school. Commonly used for various content concerning writing and schooling.",
  },
  {
    "web-scraper-order": "1666026282-1203",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📚 Books",
    "objects-href": "https://emojipedia.org/books/",
    emoji: "📚",
    emojiName: "📚 Books",
    description:
      "A loose stack of three of more different-colored, hardcover books. Commonly used for various content concerning reading and schooling. Color and orientation vary across platforms, but often shown with red, green, and blue covers.",
  },
  {
    "web-scraper-order": "1666026285-1204",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📙 Orange Book",
    "objects-href": "https://emojipedia.org/orange-book/",
    emoji: "📙",
    emojiName: "📙 Orange Book",
    description:
      "A closed, orange, hardcover book—similar to the Emojipedia logo 📙😃. Commonly used for various content concerning reading, writing, learning, and schooling. May also be used as an orange accent color.",
  },
  {
    "web-scraper-order": "1666026287-1205",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📘 Blue Book",
    "objects-href": "https://emojipedia.org/blue-book/",
    emoji: "📘",
    emojiName: "📘 Blue Book",
    description:
      "A closed, blue, hardcover book. Commonly used for various content concerning reading, writing, learning, and schooling. May also be used as a blue accent color.",
  },
  {
    "web-scraper-order": "1666026289-1206",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📗 Green Book",
    "objects-href": "https://emojipedia.org/green-book/",
    emoji: "📗",
    emojiName: "📗 Green Book",
    description:
      "A closed, green, hardcover book. Commonly used for various content concerning reading, writing, learning, and schooling. May also be used as a green accent color.",
  },
  {
    "web-scraper-order": "1666026292-1207",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📖 Open Book",
    "objects-href": "https://emojipedia.org/open-book/",
    emoji: "📖",
    emojiName: "📖 Open Book",
    description:
      "An open, hardcover book, depicted with a blue cover on most platforms. Some platforms include a bookmark. Commonly used for various content concerning reading, writing, learning, and schooling.",
  },
  {
    "web-scraper-order": "1666026294-1208",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📕 Closed Book",
    "objects-href": "https://emojipedia.org/closed-book/",
    emoji: "📕",
    emojiName: "📕 Closed Book",
    description:
      "A closed, hardcover book depicted with a red cover on most platforms. Commonly used for various content concerning reading, writing, learning, and schooling. May also be used as a red accent color.",
  },
  {
    "web-scraper-order": "1666026298-1209",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📔 Notebook with Decorative Cover",
    "objects-href": "https://emojipedia.org/notebook-with-decorative-cover/",
    emoji: "📔",
    emojiName: "📔 Notebook with Decorative Cover",
    description:
      "A closed, hardcover notebook, as used for journaling or sketching. Appearance varies across platforms, with most designs featuring relatively plain covers. Commonly used for content concerning writing and schooling.",
  },
  {
    "web-scraper-order": "1666026300-1210",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🪔 Diya Lamp",
    "objects-href": "https://emojipedia.org/diya-lamp/",
    emoji: "🪔",
    emojiName: "🪔 Diya Lamp",
    description:
      "A lamp made of brass or clay, displayed with a lit wick leading into oil or ghee.",
  },
  {
    "web-scraper-order": "1666026303-1211",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🏮 Red Paper Lantern",
    "objects-href": "https://emojipedia.org/red-paper-lantern/",
    emoji: "🏮",
    emojiName: "🏮 Red Paper Lantern",
    description:
      "A red paper lantern, as hangs outside an izakaya, a Japanese bar that serves drinks and casual food. Generally depicted as cylindrical with a black top and base and soft, orange glow.",
  },
  {
    "web-scraper-order": "1666026306-1212",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🔦 Flashlight",
    "objects-href": "https://emojipedia.org/flashlight/",
    emoji: "🔦",
    emojiName: "🔦 Flashlight",
    description:
      "An everyday flashlight (electric torch), as used when the power goes out, camping, or telling scary stories. Generally depicted at a 45° angle as a gray and black device with a switch, shown illuminated on many platforms.",
  },
  {
    "web-scraper-order": "1666026317-1213",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "💡 Light Bulb",
    "objects-href": "https://emojipedia.org/light-bulb/",
    emoji: "💡",
    emojiName: "💡 Light Bulb",
    description:
      "A light bulb, as screwed into a lamp to light a room. Depicted as an incandescent bulb with a silver base, often shown with filament and a soft, yellow-white glow.",
  },
  {
    "web-scraper-order": "1666026319-1214",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🕯️ Candle",
    "objects-href": "https://emojipedia.org/candle/",
    emoji: "🕯️",
    emojiName: "🕯️ Candle",
    description:
      "A burning candle, as lit when taking a bath or the power is out. Depicted as a white, pillar-shaped candle with a flame and wax dripping down its sides.",
  },
  {
    "web-scraper-order": "1666026321-1215",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🔎 Magnifying Glass Tilted Right",
    "objects-href": "https://emojipedia.org/magnifying-glass-tilted-right/",
    emoji: "🔎",
    emojiName: "🔎 Magnifying Glass Tilted Right",
    description:
      "A classic magnifying glass, as used to view small objects, with its lens pointed right. Generally depicted at a 45° angle with a black handle and a clear or blue, silver-framed lens titled to the upper right.",
  },
  {
    "web-scraper-order": "1666026323-1216",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🔍 Magnifying Glass Tilted Left",
    "objects-href": "https://emojipedia.org/magnifying-glass-tilted-left/",
    emoji: "🔍",
    emojiName: "🔍 Magnifying Glass Tilted Left",
    description:
      "A classic magnifying glass, as used to view small objects, with its lens pointed left. Generally depicted at a 45° angle with a black handle and a clear or blue, silver-framed lens titled to the upper left.",
  },
  {
    "web-scraper-order": "1666026326-1217",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📼 Videocassette",
    "objects-href": "https://emojipedia.org/videocassette/",
    emoji: "📼",
    emojiName: "📼 Videocassette",
    description:
      "A videotape cassette, as a VHS tape used to watch movies or record TV on VCRs before DVDs , DVRs, and streaming. Generally depicted as a black cassette with a white label between its reels.",
  },
  {
    "web-scraper-order": "1666026328-1218",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📹 Video Camera",
    "objects-href": "https://emojipedia.org/video-camera/",
    emoji: "📹",
    emojiName: "📹 Video Camera",
    description:
      "A video camera, as a camcorder used to film home videos in the 1980–90s. Generally depicted as a gray or black video camera with viewfinder, control buttons, and lens pointed left.",
  },
  {
    "web-scraper-order": "1666026331-1219",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📸 Camera with Flash",
    "objects-href": "https://emojipedia.org/camera-with-flash/",
    emoji: "📸",
    emojiName: "📸 Camera with Flash",
    description:
      "A classic camera, shown with its flash going off, as to illuminate a darker scene. Vendors implement the same design as 📷 Camera with a burst of light, often resembling 💥 Collision.",
  },
  {
    "web-scraper-order": "1666026333-1220",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📷 Camera",
    "objects-href": "https://emojipedia.org/camera/",
    emoji: "📷",
    emojiName: "📷 Camera",
    description:
      "A classic camera, as an SLR used to take pictures before camera phones. Generally depicted with a black and silver casing with lens and operating controls.",
  },
  {
    "web-scraper-order": "1666026336-1221",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📺 Television",
    "objects-href": "https://emojipedia.org/television/",
    emoji: "📺",
    emojiName: "📺 Television",
    description:
      "A classic television set, as people watched before streaming on flatscreens. Depicted in various colors and styles with a screen, knobs, and, on many platforms, rabbit-ear antennae.",
  },
  {
    "web-scraper-order": "1666026338-1222",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📽️ Film Projector",
    "objects-href": "https://emojipedia.org/film-projector/",
    emoji: "📽️",
    emojiName: "📽️ Film Projector",
    description:
      "A classic film projector, as projects film onto a screen for viewing. Generally depicted as a black or gray projector with two mounted reels and lens pointed right.",
  },
  {
    "web-scraper-order": "1666026340-1223",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🎞️ Film Frames",
    "objects-href": "https://emojipedia.org/film-frames/",
    emoji: "🎞️",
    emojiName: "🎞️ Film Frames",
    description:
      "A strip of film, as used in a movie camera or photography. Generally depicted as several horizontal frames of unexposed film with black trim and perforations.",
  },
  {
    "web-scraper-order": "1666026343-1224",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🎥 Movie Camera",
    "objects-href": "https://emojipedia.org/movie-camera/",
    emoji: "🎥",
    emojiName: "🎥 Movie Camera",
    description:
      "A classic movie camera. Depicted as a black camera with two mounted reels of film, viewfinder, and lens pointed left or right.",
  },
  {
    "web-scraper-order": "1666026346-1225",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🧮 Abacus",
    "objects-href": "https://emojipedia.org/abacus/",
    emoji: "🧮",
    emojiName: "🧮 Abacus",
    description:
      "An abacus, an ancient tool used to count and calculate by moving beads. Depicted as a wooden frame with four or more rows or columns of variously positioned and colored beads.",
  },
  {
    "web-scraper-order": "1666026349-1226",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📀 DVD",
    "objects-href": "https://emojipedia.org/dvd/",
    emoji: "📀",
    emojiName: "📀 DVD",
    description:
      "A digital versatile disc (DVD), a type of optical disc used to play movies before the rise of streaming technology. Generally depicted in gold, though Facebook’s is bluish gray, as a Blu-ray.",
  },
  {
    "web-scraper-order": "1666026351-1227",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "💿 Optical Disk",
    "objects-href": "https://emojipedia.org/optical-disk/",
    emoji: "💿",
    emojiName: "💿 Optical Disk",
    description:
      "A silver optical disc, as a CD or DVD, used to play music or movies before the rise of streaming technology. Commonly used to represent CDs, DVDs, Blu-rays, and related film and music content, especially albums.",
  },
  {
    "web-scraper-order": "1666026355-1228",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "💾 Floppy Disk",
    "objects-href": "https://emojipedia.org/floppy-disk/",
    emoji: "💾",
    emojiName: "💾 Floppy Disk",
    description:
      "A 3.5-inch floppy disk, a data storage format popular in the 1980–90s but largely preserved as a Save icon in computer programs. Shown with its silver shutter positioned up and in a black housing with a white label, accented with blue or red.",
  },
  {
    "web-scraper-order": "1666026357-1229",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "💽 Computer Disk",
    "objects-href": "https://emojipedia.org/computer-disk/",
    emoji: "💽",
    emojiName: "💽 Computer Disk",
    description:
      "A minidisc, depicted as a small, silver or gold optical disc housed in a square cartridge, its shutter positioned to the right.",
  },
  {
    "web-scraper-order": "1666026360-1230",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🖲️ Trackball",
    "objects-href": "https://emojipedia.org/trackball/",
    emoji: "🖲️",
    emojiName: "🖲️ Trackball",
    description:
      "A trackball, as rotated to control a cursor on a computer. An alternative or supplement to a computer mouse or touchpad. Generally depicted as a cordless device with a blue or red ball in a cylindrical, black or gray socket.",
  },
  {
    "web-scraper-order": "1666026362-1231",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🖱️ Computer Mouse",
    "objects-href": "https://emojipedia.org/computer-mouse/",
    emoji: "🖱️",
    emojiName: "🖱️ Computer Mouse",
    description:
      "A mouse, as used to control a cursor on a computer. Generally depicted as a white or gray, cordless device with a scroll wheel between left- and right-click buttons.",
  },
  {
    "web-scraper-order": "1666026365-1232",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "⌨️ Keyboard",
    "objects-href": "https://emojipedia.org/keyboard/",
    emoji: "⌨️",
    emojiName: "⌨️ Keyboard",
    description:
      "A keyboard, as used to type on a computer. Generally depicted as a gray device with white or black keys. Used for various content concerning computers, typing, and writing.",
  },
  {
    "web-scraper-order": "1666026368-1233",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🖨️ Printer",
    "objects-href": "https://emojipedia.org/printer/",
    emoji: "🖨️",
    emojiName: "🖨️ Printer",
    description:
      "A computer printer, as at a home office. Generally depicted as a grayish device with a power button and paper loaded in its tray, sometimes printing out a document. May be used for various content concerning printing, including as a Print icon, as well as for office work and technology more generally.",
  },
  {
    "web-scraper-order": "1666026371-1234",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🖥️ Desktop Computer",
    "objects-href": "https://emojipedia.org/desktop-computer/",
    emoji: "🖥️",
    emojiName: "🖥️ Desktop Computer",
    description:
      "A desktop personal computer. Generally depicted as a black or gray monitor with a dark or blue screen.",
  },
  {
    "web-scraper-order": "1666026373-1235",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "💻 Laptop",
    "objects-href": "https://emojipedia.org/laptop/",
    emoji: "💻",
    emojiName: "💻 Laptop",
    description:
      "A laptop personal computer. Depicted as a black or gray device, opened to show a dark or blue screen, keyboard, and touchpad.",
  },
  {
    "web-scraper-order": "1666026375-1236",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🔌 Electric Plug",
    "objects-href": "https://emojipedia.org/electric-plug/",
    emoji: "🔌",
    emojiName: "🔌 Electric Plug",
    description:
      "An electric plug, as inserted into socket to power a device. Depicted as a black, two-pronged plug at various angles at the end of a cable. Prongs are silver or gold.",
  },
  {
    "web-scraper-order": "1666026378-1237",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🔋 Battery",
    "objects-href": "https://emojipedia.org/battery/",
    emoji: "🔋",
    emojiName: "🔋 Battery",
    description:
      "An electric battery, as used to power such devices as a flashlight. Generally depicted as an upright, green cylinder, as a AA or D cell, with white indicators for its positive (facing up) and negative terminals.",
  },
  {
    "web-scraper-order": "1666026381-1238",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📠 Fax Machine",
    "objects-href": "https://emojipedia.org/fax-machine/",
    emoji: "📠",
    emojiName: "📠 Fax Machine",
    description:
      "A fax machine, as scans and transmits documents over a telephone line. Common in the 1980–90s before the internet. Depicted as a white or black machine with a telephone handset, keypad, display screen, and paper in its tray.",
  },
  {
    "web-scraper-order": "1666026385-1239",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📟 Pager",
    "objects-href": "https://emojipedia.org/pager/",
    emoji: "📟",
    emojiName: "📟 Pager",
    description:
      "A pager, as worn on the waist to alert a person to a phone call or short text message. Popular in the 1980–90s before mobile phones, though still used by some medical and emergency personnel. Very occasionally used to represent alerts, digital communication, or nostalgia for old technology.",
  },
  {
    "web-scraper-order": "1666026404-1240",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📞 Telephone Receiver",
    "objects-href": "https://emojipedia.org/telephone-receiver/",
    emoji: "📞",
    emojiName: "📞 Telephone Receiver",
    description:
      "The handset of a traditional telephone, with speaker and microphone. Generally depicted in black at a 45° angle.",
  },
  {
    "web-scraper-order": "1666026408-1241",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "☎️ Telephone",
    "objects-href": "https://emojipedia.org/telephone/",
    emoji: "☎️",
    emojiName: "☎️ Telephone",
    description:
      "A classic telephone, as a landline home phone. Most platforms depict a red, push-button phone with the handset on the base. Some platforms feature designs with rotary dials.",
  },
  {
    "web-scraper-order": "1666026411-1242",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📲 Mobile Phone with Arrow",
    "objects-href": "https://emojipedia.org/mobile-phone-with-arrow/",
    emoji: "📲",
    emojiName: "📲 Mobile Phone with Arrow",
    description:
      "A mobile phone (cell phone) with a rightward arrow pointed at it from the left. Intended to indicate an incoming call or message, but used to represent mobile phones, technology, and communication more generally.",
  },
  {
    "web-scraper-order": "1666026414-1243",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📱 Mobile Phone",
    "objects-href": "https://emojipedia.org/mobile-phone/",
    emoji: "📱",
    emojiName: "📱 Mobile Phone",
    description:
      "A mobile phone (cell phone), as used to text, check social media, or take selfies. Depicted as a black or gray smartphone with a generic blue screen or multicolored app icons. Commonly used for various content concerning mobile phones, technology, and communication.",
  },
  {
    "web-scraper-order": "1666026417-1244",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🪕 Banjo",
    "objects-href": "https://emojipedia.org/banjo/",
    emoji: "🪕",
    emojiName: "🪕 Banjo",
    description:
      "A banjo with a round body and a long neck. Used to talk about banjos or music in general.",
  },
  {
    "web-scraper-order": "1666026443-1245",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📻 Radio",
    "objects-href": "https://emojipedia.org/radio/",
    emoji: "📻",
    emojiName: "📻 Radio",
    description:
      "A classic portable radio, as used to listen to music, news, or sports. Depicted in various colors and styles with a speaker, antenna, dial, and knobs.",
  },
  {
    "web-scraper-order": "1666026446-1246",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🎛️ Control Knobs",
    "objects-href": "https://emojipedia.org/control-knobs/",
    emoji: "🎛️",
    emojiName: "🎛️ Control Knobs",
    description:
      "Four control knobs, as adjust audio levels on a mixing console. Generally depicted as a silver square with black knobs, turned to various levels as indicated by white pointers and scale markings.",
  },
  {
    "web-scraper-order": "1666026449-1247",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🎚️ Level Slider",
    "objects-href": "https://emojipedia.org/level-slider/",
    emoji: "🎚️",
    emojiName: "🎚️ Level Slider",
    description:
      "A level slider, as adjusts volume on a mixing console. Most platforms depict a silver and black channel fader with scale markings, set to various levels. Apple and Google's go up to eleven.",
  },
  {
    "web-scraper-order": "1666026451-1248",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🎙️ Studio Microphone",
    "objects-href": "https://emojipedia.org/studio-microphone/",
    emoji: "🎙️",
    emojiName: "🎙️ Studio Microphone",
    description:
      "A microphone, as used for radio broadcasting or studio recording. Most platforms depict a vintage, silver microphone, like the Shure Unidyne 55.",
  },
  {
    "web-scraper-order": "1666026454-1249",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📯 Postal Horn",
    "objects-href": "https://emojipedia.org/postal-horn/",
    emoji: "📯",
    emojiName: "📯 Postal Horn",
    description:
      "A postal horn (post horn). Depicted as a coiled, valveless, brass horn, like a bugle or trumpet, with two red tassels. Sometimes used to mark announcements as well as for various content concerning brass instruments, music, or mail.",
  },
  {
    "web-scraper-order": "1666026458-1250",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "💎 Gem Stone",
    "objects-href": "https://emojipedia.org/gem-stone/",
    emoji: "💎",
    emojiName: "💎 Gem Stone",
    description:
      "A jewel or gem, as set into a ring. Depicted in the shape of a classic diamond but in the bright blue color of an aquamarine.",
  },
  {
    "web-scraper-order": "1666026460-1251",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📿 Prayer Beads",
    "objects-href": "https://emojipedia.org/prayer-beads/",
    emoji: "📿",
    emojiName: "📿 Prayer Beads",
    description:
      "A string of beads, as used in prayer or meditation in many religious traditions. Generally depicted as red, wooden beads with a gold, decorative center bead and tassel.",
  },
  {
    "web-scraper-order": "1666026463-1252",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🛍️ Shopping Bags",
    "objects-href": "https://emojipedia.org/shopping-bags/",
    emoji: "🛍️",
    emojiName: "🛍️ Shopping Bags",
    description:
      "Two colorful shopping bags, as contain consumer items bought at a department store. Depicted as gift bags in various bright colors, patterns, sizes, and positions across platforms. Apple's design, for instance, features a pink bag with light-pink dots in front of a gold bag with yellow stripes.",
  },
  {
    "web-scraper-order": "1666026466-1253",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🪢 Knot",
    "objects-href": "https://emojipedia.org/knot/",
    emoji: "🪢",
    emojiName: "🪢 Knot",
    description:
      "Brightly colored rope forming a knot. Knot type varies across platform, with most designs showing a square knot, a figure eight knot, or a carrick bend. Samsung's design appears to be a carrick bend, but upon closer inspection, it is not correctly tied and would fall apart with a gentle tug.",
  },
  {
    "web-scraper-order": "1666026468-1254",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🧶 Yarn",
    "objects-href": "https://emojipedia.org/yarn/",
    emoji: "🧶",
    emojiName: "🧶 Yarn",
    description:
      "A ball of yarn, as used to knit a scarf. Color varies across platforms, but often depicted in green, blue, or magenta and shown with an end unraveling. Sometimes depicted with a pair of knitting needles stuck in the ball.",
  },
  {
    "web-scraper-order": "1666026470-1255",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🪡 Sewing Needle",
    "objects-href": "https://emojipedia.org/sewing-needle/",
    emoji: "🪡",
    emojiName: "🪡 Sewing Needle",
    description:
      "A threaded silver needle. Color of thread varies from platform to platform.",
  },
  {
    "web-scraper-order": "1666026473-1256",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🧵 Thread",
    "objects-href": "https://emojipedia.org/thread/",
    emoji: "🧵",
    emojiName: "🧵 Thread",
    description:
      "A spool of thread, as used for sewing. Thread color varies across platforms, though often depicted in red or blue and on a wooden spool. Sometimes shown with an end unraveling.",
  },
  {
    "web-scraper-order": "1666026475-1257",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🖼️ Framed Picture",
    "objects-href": "https://emojipedia.org/framed-picture/",
    emoji: "🖼️",
    emojiName: "🖼️ Framed Picture",
    description:
      "A framed picture of a painting or photograph, as displayed in a gallery or on a household wall. Vendors feature various scenes, though generally a lush, sunny landscape of hills and mountains, in a gold frame.",
  },
  {
    "web-scraper-order": "1666026478-1258",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🪆 Nesting Dolls",
    "objects-href": "https://emojipedia.org/nesting-dolls/",
    emoji: "🪆",
    emojiName: "🪆 Nesting Dolls",
    description:
      "Nesting dolls, also called matryoshka dolls or Russian dolls, decorated with bright colors including red, yellow, blue, and green. All platforms depict the nesting dolls as open, revealing smaller dolls within the bases of larger dolls. Dolls are all decorated with women wearing headscarfs. Some platforms show a flower motif on the women's dresses or aprons.",
  },
  {
    "web-scraper-order": "1666026480-1259",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🪅 Piñata",
    "objects-href": "https://emojipedia.org/pinata/",
    emoji: "🪅",
    emojiName: "🪅 Piñata",
    description:
      "A colorful decorated container that comes in many shapes, a piñata is filled with candy or toys. Hit to break open for celebrations such as Cinco de Mayo, this is generally associated with Mexico.",
  },
  {
    "web-scraper-order": "1666026486-1260",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🧸 Teddy Bear",
    "objects-href": "https://emojipedia.org/teddy-bear/",
    emoji: "🧸",
    emojiName: "🧸 Teddy Bear",
    description:
      "A classic teddy bear, as snuggled by a child when going to sleep.",
  },
  {
    "web-scraper-order": "1666026488-1261",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🕹️ Joystick",
    "objects-href": "https://emojipedia.org/joystick/",
    emoji: "🕹️",
    emojiName: "🕹️ Joystick",
    description:
      "A joystick, as used in playing classic arcade, computer, or video games. Generally depicted with a black base, red-knobbed control stick, and one or more red buttons.",
  },
  {
    "web-scraper-order": "1666026491-1262",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🪬 Hamsa",
    "objects-href": "https://emojipedia.org/hamsa/",
    emoji: "🪬",
    emojiName: "🪬 Hamsa",
    description: "A blue hand with an eye in the center of the palm.",
  },
  {
    "web-scraper-order": "1666026493-1263",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🧿 Nazar Amulet",
    "objects-href": "https://emojipedia.org/nazar-amulet/",
    emoji: "🧿",
    emojiName: "🧿 Nazar Amulet",
    description:
      "A nazar, an eye-shaped amulet believed to protect against the evil eye, especially in Turkish culture. Depicted as a rich blue, circular bead with a black dot in the center ringed with white and light blue, resembling an eye.",
  },
  {
    "web-scraper-order": "1666026495-1264",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🪄 Magic Wand",
    "objects-href": "https://emojipedia.org/magic-wand/",
    emoji: "🪄",
    emojiName: "🪄 Magic Wand",
    description:
      "A wand with sparkles (✨magic✨) coming out of its end. Most platforms show a classic magician-style magic wand that's black with white tips. WhatsApp shows a golden magic wand tipped with a star, similar to the wand that Glenda the Good Witch uses in the 1939 film The Wizard of Oz.",
  },
  {
    "web-scraper-order": "1666026499-1265",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🔮 Crystal Ball",
    "objects-href": "https://emojipedia.org/crystal-ball/",
    emoji: "🔮",
    emojiName: "🔮 Crystal Ball",
    description:
      "A crystal ball, as a fortune teller or clairvoyant gazes into to tell the future. Depicted as a sparkling, purple or blue crystal orb resting on a stand.",
  },
  {
    "web-scraper-order": "1666026502-1266",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🪁 Kite",
    "objects-href": "https://emojipedia.org/kite/",
    emoji: "🪁",
    emojiName: "🪁 Kite",
    description:
      "A diamond-shaped kite with a tail. This emoji appears in various colors across platforms.",
  },
  {
    "web-scraper-order": "1666026505-1267",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🪀 Yo-Yo",
    "objects-href": "https://emojipedia.org/yo-yo/",
    emoji: "🪀",
    emojiName: "🪀 Yo-Yo",
    description:
      "A round yo-yo with its string coming out. It appears in various colors and designs across platforms, occasionally with a ⭐ Star on its side.",
  },
  {
    "web-scraper-order": "1666026507-1268",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🤿 Diving Mask",
    "objects-href": "https://emojipedia.org/diving-mask/",
    emoji: "🤿",
    emojiName: "🤿 Diving Mask",
    description:
      "A diving mask with a snorkel, used for scuba diving or other underwater activities. Colors vary across platforms.",
  },
  {
    "web-scraper-order": "1666026510-1269",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🎁 Wrapped Gift",
    "objects-href": "https://emojipedia.org/wrapped-gift/",
    emoji: "🎁",
    emojiName: "🎁 Wrapped Gift",
    description:
      "A present or gift in a box tied with a bow, as given on a birthday or Christmas. Box and ribbon color vary across platforms, but commonly depicted as a gold box with a lid wrapped with a red ribbon.",
  },
  {
    "web-scraper-order": "1666026513-1270",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🎀 Ribbon",
    "objects-href": "https://emojipedia.org/ribbon/",
    emoji: "🎀",
    emojiName: "🎀 Ribbon",
    description:
      "A pink or red ribbon, as tied into a bow on a gift or woman's hat.",
  },
  {
    "web-scraper-order": "1666026516-1271",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🧧 Red Envelope",
    "objects-href": "https://emojipedia.org/red-envelope/",
    emoji: "🧧",
    emojiName: "🧧 Red Envelope",
    description:
      "A red envelope, as gifted with money on Chinese New Year or on other joyous occasions, such as weddings, in Chinese and some other Asian cultures around the world.",
  },
  {
    "web-scraper-order": "1666026519-1272",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🎐 Wind Chime",
    "objects-href": "https://emojipedia.org/wind-chime/",
    emoji: "🎐",
    emojiName: "🎐 Wind Chime",
    description:
      "A Japanese wind chime. Depicted as a glass bell with a strip of paper suspended from its clapper, often decorated with cherry blossom-like flowers.",
  },
  {
    "web-scraper-order": "1666026521-1273",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🎏 Carp Streamer",
    "objects-href": "https://emojipedia.org/carp-streamer/",
    emoji: "🎏",
    emojiName: "🎏 Carp Streamer",
    description:
      "Japanese koinobori, decorative, carp-shaped windsocks flown in celebration of Children’s Day on May 5 in Japan. Generally depicted as a blue and red stylized carp fish on a golden pole.",
  },
  {
    "web-scraper-order": "1666026526-1274",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🎎 Japanese Dolls",
    "objects-href": "https://emojipedia.org/japanese-dolls/",
    emoji: "🎎",
    emojiName: "🎎 Japanese Dolls",
    description:
      "Ornamental Japanese Emperor and Empress dolls, as displayed in celebration of Hinamatsuri on March 3 in Japan (Girls’ or Dolls’ Day).",
  },
  {
    "web-scraper-order": "1666026530-1275",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🎊 Confetti Ball",
    "objects-href": "https://emojipedia.org/confetti-ball/",
    emoji: "🎊",
    emojiName: "🎊 Confetti Ball",
    description:
      "A golden ball, split in two halves in a shower of multicolored confetti and streamers.",
  },
  {
    "web-scraper-order": "1666026534-1276",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🎉 Party Popper",
    "objects-href": "https://emojipedia.org/party-popper/",
    emoji: "🎉",
    emojiName: "🎉 Party Popper",
    description:
      "A party popper, as explodes in a shower of confetti and streamers at a celebration. Generally depicted as a gold party hat, striped on some platforms, at a 45° angle, with multicolored confetti and streamers coming from its opening at the upper right. Twitter’s cone is red.",
  },
  {
    "web-scraper-order": "1666026537-1277",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🎈 Balloon",
    "objects-href": "https://emojipedia.org/balloon/",
    emoji: "🎈",
    emojiName: "🎈 Balloon",
    description:
      "A balloon on a string, as decorates a birthday party. Generally depicted in red, though WhatsApp’s is pink and Google’s orangish-red.",
  },
  {
    "web-scraper-order": "1666026539-1278",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🧨 Firecracker",
    "objects-href": "https://emojipedia.org/firecracker/",
    emoji: "🧨",
    emojiName: "🧨 Firecracker",
    description:
      "A firecracker, as lit on Chinese New Year, New Year's Eve, or Independence Day. Depicted as a red tube with a burning fuse, sometimes lined with gold rings at its top and base.",
  },
  {
    "web-scraper-order": "1666026542-1279",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "⛱️ Umbrella on Ground",
    "objects-href": "https://emojipedia.org/umbrella-on-ground/",
    emoji: "⛱️",
    emojiName: "⛱️ Umbrella on Ground",
    description:
      "A large, open umbrella, as provides shade at a beach or patio. Generally depicted as a striped umbrella inserted into a patch of sand and tilted to the right.",
  },
  {
    "web-scraper-order": "1666026545-1280",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🌡️ Thermometer",
    "objects-href": "https://emojipedia.org/thermometer/",
    emoji: "🌡️",
    emojiName: "🌡️ Thermometer",
    description:
      "A liquid-in-glass thermometer, as used to measure temperature. Depicted at various angles with a red liquid risen from the bulb to various levels on the scale. Commonly used for content concerning high temperatures, including warm weather, illness (having a fever), and various slang senses of hot.",
  },
  {
    "web-scraper-order": "1666026550-1281",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🕰️ Mantelpiece Clock",
    "objects-href": "https://emojipedia.org/mantelpiece-clock/",
    emoji: "🕰️",
    emojiName: "🕰️ Mantelpiece Clock",
    description:
      "An antique-styled mantel clock with a flat base and rounded case, as made of wood and brass and placed above a fireplace.",
  },
  {
    "web-scraper-order": "1666026555-1282",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "⏲️ Timer Clock",
    "objects-href": "https://emojipedia.org/timer-clock/",
    emoji: "⏲️",
    emojiName: "⏲️ Timer Clock",
    description:
      "Time’s up! A timer set to count down and sound an alarm after a designated amount of time, as used in the kitchen. Appearance varies by platform. Commonly used for various content concerning time, including countdowns and deadlines.",
  },
  {
    "web-scraper-order": "1666026560-1283",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "⏱️ Stopwatch",
    "objects-href": "https://emojipedia.org/stopwatch/",
    emoji: "⏱️",
    emojiName: "⏱️ Stopwatch",
    description:
      "An analog, handheld timepiece used to measure elapsed time, as for athletic sprints. Appearance varies across platforms, but depicted with two or more control buttons on its top.",
  },
  {
    "web-scraper-order": "1666026563-1285",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "⏰ Alarm Clock",
    "objects-href": "https://emojipedia.org/alarm-clock/",
    emoji: "⏰",
    emojiName: "⏰ Alarm Clock",
    description:
      "A timepiece set in advance to startle a person awake at the designated time with its two bells. That is, before hitting snooze. Appearance varies across platforms, but depicted as a classic, wind-up, bedside alarm clock, often red in color.",
  },
  {
    "web-scraper-order": "1666026567-1287",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "⌚ Watch",
    "objects-href": "https://emojipedia.org/watch/",
    emoji: "⌚",
    emojiName: "⌚ Watch",
    description:
      "A wristwatch, as used for telling time. Appearance varies across platforms, but widely depicted as an analog timepiece with a white face and brown or black straps.",
  },
  {
    "web-scraper-order": "1666026572-1290",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "⏳ Hourglass Not Done",
    "objects-href": "https://emojipedia.org/hourglass-not-done/",
    emoji: "⏳",
    emojiName: "⏳ Hourglass Not Done",
    description:
      "A classic hourglass, its sand still flowing from the top to bottom bulb. Indicates time is still passing—but life is short. Color varies across platforms.",
  },
  {
    "web-scraper-order": "1666026576-1292",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "⌛ Hourglass Done",
    "objects-href": "https://emojipedia.org/hourglass-done/",
    emoji: "⌛",
    emojiName: "⌛ Hourglass Done",
    description:
      "A classic hourglass, all of its sand having flowed into the bottom bulb. Indicates time has passed. Color varies across platforms.",
  },
  {
    "web-scraper-order": "1666026579-1294",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🧳 Luggage",
    "objects-href": "https://emojipedia.org/luggage/",
    emoji: "🧳",
    emojiName: "🧳 Luggage",
    description:
      "A suitcase or bag, as used for traveling. Most platforms depict gray or blue rolling luggage with an extended handle. Commonly used for various content concerning traveling or taking trips, whether for business or leisure.",
  },
  {
    "web-scraper-order": "1666026582-1296",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🛎️ Bellhop Bell",
    "objects-href": "https://emojipedia.org/bellhop-bell/",
    emoji: "🛎️",
    emojiName: "🛎️ Bellhop Bell",
    description:
      "Ding! A call bell, as pressed at a front desk or reception to alert staff for service, such as from a concierge or bellhop (porter) to carry luggage at a hotel. Generally depicted as a golden bell on a wooden stand.",
  },
  {
    "web-scraper-order": "1666026585-1298",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🛢️ Oil Drum",
    "objects-href": "https://emojipedia.org/oil-drum/",
    emoji: "🛢️",
    emojiName: "🛢️ Oil Drum",
    description:
      "A barrel for transporting bulk liquids, such as oil. Generally depicted as a red or blue metal drum with holes or a stopper on its lid. Commonly used for various content concerning petroleum or hazardous waste.",
  },
  {
    "web-scraper-order": "1666026589-1300",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🦼 Motorized Wheelchair",
    "objects-href": "https://emojipedia.org/motorized-wheelchair/",
    emoji: "🦼",
    emojiName: "🦼 Motorized Wheelchair",
    description:
      "A motorized wheelchair. Most platforms show a red and black or blue and black wheelchair. Distinct from ♿ Wheelchair Symbol which is used as signage to indicate accessible facilities. See also 👩‍🦼Woman in Motorized Wheelchair or 👨‍🦼Man in Motorized Wheelchair.",
  },
  {
    "web-scraper-order": "1666026591-1302",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🦽 Manual Wheelchair",
    "objects-href": "https://emojipedia.org/manual-wheelchair/",
    emoji: "🦽",
    emojiName: "🦽 Manual Wheelchair",
    description:
      "A manual wheelchair. Most platforms show a red and black or blue and black wheelchair. Distinct from ♿ Wheelchair Symbol, which is used as signage to indicate accessible facilities. See also 👩‍🦽Woman in Manual Wheelchair or 👨‍🦽Man in Manual Wheelchair.",
  },
  {
    "web-scraper-order": "1666026596-1304",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "💈 Barber Pole",
    "objects-href": "https://emojipedia.org/barber-pole/",
    emoji: "💈",
    emojiName: "💈 Barber Pole",
    description:
      "A pole spiraled with red, white, and blue stripes, as spins out front of a barbershop. Commonly used for various content concerning haircutting and hairstyling.",
  },
  {
    "web-scraper-order": "1666026598-1305",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🧱 Brick",
    "objects-href": "https://emojipedia.org/brick/",
    emoji: "🧱",
    emojiName: "🧱 Brick",
    description:
      "A red brick or bricks. Depicted in a loose stack, a single object with holes, or as built into wall, as of a house, school, or other structure.",
  },
  {
    "web-scraper-order": "1666026604-1308",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🧭 Compass",
    "objects-href": "https://emojipedia.org/compass/",
    emoji: "🧭",
    emojiName: "🧭 Compass",
    description:
      "A magnetic compass, as used for navigation. Generally depicted in a silver or gold case with a compass rose and a red-tipped needle. Commonly used for various content concerning traveling and exploring as well as metaphorical compasses (e.g., moral compass).",
  },
  {
    "web-scraper-order": "1666026607-1310",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🗺️ World Map",
    "objects-href": "https://emojipedia.org/world-map/",
    emoji: "🗺️",
    emojiName: "🗺️ World Map",
    description:
      "A rectangular map of the world. Generally depicted as a paper map creased at its folds, Earth’s surface shown in green on blue ocean.",
  },
  {
    "web-scraper-order": "1666026610-1312",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🏺 Amphora",
    "objects-href": "https://emojipedia.org/amphora/",
    emoji: "🏺",
    emojiName: "🏺 Amphora",
    description:
      "A tall, ceramic jar with two handles and a narrow neck and foot. Represents an amphora, as used by ancient Greeks and Romans to hold water and wine.",
  },
  {
    "web-scraper-order": "1666026614-1314",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🔪 Kitchen Knife",
    "objects-href": "https://emojipedia.org/kitchen-knife/",
    emoji: "🔪",
    emojiName: "🔪 Kitchen Knife",
    description:
      "A knife with a long steel blade, as a chef uses to slice meat or vegetables. Depicted with a black or brown handle and positioned at a 45° angle, often with its point at the lower right.",
  },
  {
    "web-scraper-order": "1666026617-1316",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🛌 Person in Bed",
    "objects-href": "https://emojipedia.org/person-in-bed/",
    emoji: "🛌",
    emojiName: "🛌 Person in Bed",
    description:
      "A bed with a gender-unspecified person sleeping in it, as at a house, hotel, hostel, or other sleeping accommodation. Used especially for various content concerning sleeping as well as beds, furniture, housing, relaxing, and other bedroom activities.",
  },
  {
    "web-scraper-order": "1666026622-1318",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🛀 Person Taking Bath",
    "objects-href": "https://emojipedia.org/person-taking-bath/",
    emoji: "🛀",
    emojiName: "🛀 Person Taking Bath",
    description:
      "A gender-unspecified person taking a soothing bath in a white tub with a shower head. Commonly used for various content concerning bathing, washing, cleaning, and bathrooms more generally. May also represent relaxation and self-care.",
  },
  {
    "web-scraper-order": "1666026626-1321",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "💣 Bomb",
    "objects-href": "https://emojipedia.org/bomb/",
    emoji: "💣",
    emojiName: "💣 Bomb",
    description:
      "A cartoon-styled bomb, depicted as a black ball with a burning fuse.",
  },
  {
    "web-scraper-order": "1666026629-1323",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🕳️ Hole",
    "objects-href": "https://emojipedia.org/hole/",
    emoji: "🕳️",
    emojiName: "🕳️ Hole",
    description:
      "A round, black, cartoon-styled hole, as a manhole or a hole (cup) in golf. May be used to represent various types of literal or figurative holes, e.g., black holes, rabbit holes.",
  },
  {
    "web-scraper-order": "1666026634-1326",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "💌 Love Letter",
    "objects-href": "https://emojipedia.org/love-letter/",
    emoji: "💌",
    emojiName: "💌 Love Letter",
    description:
      "The back of an envelope, generally shown in white and sealed with a red heart. Represents a love letter or note, valentine, or affectionate greeting card. Commonly used to convey various feelings or messages of love and happiness.",
  },
];
export default object;
